import { render, staticRenderFns } from "./PaymentRed.vue?vue&type=template&id=3e780938&scoped=true"
import script from "./PaymentRed.vue?vue&type=script&lang=js"
export * from "./PaymentRed.vue?vue&type=script&lang=js"
import style0 from "./PaymentRed.vue?vue&type=style&index=0&id=3e780938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e780938",
  null
  
)

export default component.exports